import React from "react";
import { Row, Col, Divider } from "antd";
import { ClaimsByInstitutionOutcomeChart, ClaimsByGroundsAndInstitutionOutcomeChart, ClaimsByOutcomeAtInstitutionChart, ClaimsByGroundsAndOutcomeAtInstitutionChart } from "./charts";
import UserAccess from "../../../../components/common/user-access";
import { keepOnlyPTABQueryStrings } from "../../../../helpers/url";

const styles = {
  centeredHeader: {
    textAlign: "center"
  }
};

const ClaimTabOutcome = props => {
  const q = keepOnlyPTABQueryStrings(props.location.query);
  return (
    <UserAccess isPublicSignupAllowed={true} showHelp={true} style={styles.centeredHeader}>
      <h2>{"OUTCOMES FOR CHALLENGED CLAIMS"}</h2>
      <Row>
        <Col span={24} xl={12}>
          <ClaimsByInstitutionOutcomeChart query={q} height={450} />
        </Col>
        <Col span={24} xl={12}>
          <ClaimsByGroundsAndInstitutionOutcomeChart query={q} height={400} />
        </Col>
      </Row>
      <Divider />
      <h2>{"OUTCOMES FOR INSTITUTED CLAIMS"}</h2>
      <Row>
        <Col span={24} xl={12}>
          <ClaimsByOutcomeAtInstitutionChart query={q} height={450} />
        </Col>
        <Col span={24} xl={12}>
          <ClaimsByGroundsAndOutcomeAtInstitutionChart query={q} height={400} />
        </Col>
      </Row>
    </UserAccess>
  );
};

export default ClaimTabOutcome;
